import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import Pagination from '../components/Pagination';
import './AdminManagement.css';

const AdminSubscribers = () => {
    const [subscribers, setSubscribers] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const token = localStorage.getItem('adminToken');
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1
    });

    const fetchSubscribers = useCallback(async (page = 1) => {
        try {
            const response = await axios.get(`/api/subscribers?page=${page}&limit=10`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSubscribers(response.data.data);
            setPagination({
                currentPage: response.data.currentPage,
                totalPages: response.data.totalPages
            });
        } catch (err) {
            console.error('Fetch error:', err);
            setError('Failed to load subscriber list.');
        }
    }, [token]);

    useEffect(() => {
        fetchSubscribers(1);
    }, [fetchSubscribers]);

    const handleDelete = async (id) => {
        if (!window.confirm('Remove this subscriber from the list?')) return;
        setError('');
        setSuccess('');
        try {
            await axios.delete(`/api/subscribers/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSuccess('Subscriber removed successfully.');
            fetchSubscribers(pagination.currentPage);
            setTimeout(() => setSuccess(''), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Removal failed.');
        }
    };

    return (
        <div className="admin-manage-page">
            <header className="manage-header">
                <h1>Newsletter Subscribers</h1>
                <p>Monitor your audience and mailing list</p>
            </header>

            <div className="items-list-section" style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div style={{ marginBottom: '1.5rem' }}>
                    {error && <div className="login-error">{error}</div>}
                    {success && (
                        <div style={{
                            background: 'rgba(16, 185, 129, 0.1)',
                            border: '1px solid rgba(16, 185, 129, 0.2)',
                            color: '#6ee7b7',
                            padding: '1rem',
                            borderRadius: '12px',
                            textAlign: 'center',
                            fontSize: '0.9rem'
                        }}>
                            {success}
                        </div>
                    )}
                </div>

                <table className="subscriber-table">
                    <thead>
                        <tr>
                            <th>Email Address</th>
                            <th>Joined Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <AnimatePresence>
                            {subscribers.map((s) => (
                                <motion.tr
                                    key={s._id}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                >
                                    <td>{s.email}</td>
                                    <td>{new Date(s.subscribedAt).toLocaleDateString()}</td>
                                    <td>
                                        <button onClick={() => handleDelete(s._id)} className="delete-btn">Remove</button>
                                    </td>
                                </motion.tr>
                            ))}
                        </AnimatePresence>
                    </tbody>
                </table>
                {subscribers.length === 0 && (
                    <p style={{ textAlign: 'center', marginTop: '2rem', opacity: 0.5 }}>No active subscribers.</p>
                )}

                <Pagination
                    currentPage={pagination.currentPage}
                    totalPages={pagination.totalPages}
                    onPageChange={fetchSubscribers}
                />
            </div>

            <style>{`
        .subscriber-table {
          width: 100%;
          border-collapse: collapse;
          background: rgba(255,255,255,0.02);
          border-radius: 12px;
          overflow: hidden;
        }
        .subscriber-table th {
          text-align: left;
          padding: 1rem;
          background: rgba(255,255,255,0.05);
          color: #a5b4fc;
          font-size: 0.9rem;
        }
        .subscriber-table td {
          padding: 1rem;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          font-size: 0.95rem;
        }
        .subscriber-table tr:hover {
          background: rgba(255,255,255,0.03);
        }
      `}</style>
        </div>
    );
};

export default AdminSubscribers;
